function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  let accordion = summary.closest('.accordion');

  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if (accordion) {
    if (summary.nextElementSibling.innerHTML.replace(/(<([^>]+)>)/gi, '').trim() == '') {
      accordion.classList.add('hidden');
    } else {
      accordion.classList.remove('hidden');
    }
  }

  summary.addEventListener('click', (event) => {
    if (event.currentTarget.getAttribute('aria-expanded') === 'true') {
      event.currentTarget.setAttribute('aria-expanded', 'false');
    } else {
      event.currentTarget.setAttribute('aria-expanded', 'true');
    }

    //event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', window.location.origin);
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', window.location.origin);
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.test = 1;

    this.gradient = this.querySelector('.menu-gradient');

    this.mainDetailsToggle = this.querySelectorAll('details')[0];

    if (this.mainDetailsToggle) {
      if (this.mainDetailsToggle.classList.contains('filter__group')) {
        this.mainDetailsToggle = false;
      }
    }

    this.drawer = this.querySelector('.menu-drawer');

    this.moved = false;

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();

    if (this.nodeName === 'HEADER-DRAWER') {
      this.moved = true;
    }

    if (this.classList.contains('nomove')) {
      this.moved = true;
    }

    if (this.gradient) {
      this.gradient.addEventListener('click', this.forceClose.bind(this));
    }

    this.drawer.addEventListener('touchstart', this.handleTouchStart.bind(this));

    this.drawer.addEventListener('touchend', this.handleTouchEnd.bind(this));
  }

  connectedCallback() {
    if (this.is_header_drawer) return;
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  handleTouchStart(e) {
    if (e.changedTouches) {
      this.touch_start = e.changedTouches[0].screenX;
    } else {
      this.touch_start = e.screenX;
    }
  }

  handleTouchEnd(e) {
    if (e.changedTouches) {
      this.touch_end = e.changedTouches[0].screenX;
    } else {
      this.touch_end = e.screenX;
    }

    this.handleSwipe();
  }

  handleSwipe() {
    const delta = this.touch_start - this.touch_end;

    if (delta < -150) {
      this.close();
    }
  }

  close() {
    this.closeMenuDrawer(true);
  }

  forceClose(e) {
    if (e.target === this.gradient) {
      this.closeMenuDrawer(true);
    }
  }

  bindEvents() {
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.addEventListener('click', (e) => {
        if (this.mainDetailsToggle.hasAttribute('href')) {
          e.preventDefault();
          window.location.href = this.mainDetailsToggle.getAttribute('href');
        }
      });

      this.mainDetailsToggle.childNodes.forEach((node) => {
        if (node.nodeName === 'SUMMARY') {
          node.addEventListener('click', this.onSummaryClick.bind(this));
        }
      });
    }

    this.querySelectorAll('button:not(.slider-button)').forEach((button) => {
      if (!button.classList.contains('no-trigger')) {
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      }
    });
  }

  onKeyUp(event) {
    if (!event.code || event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('.form__input, button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  setTrigger(trigger) {
    this.trigger = trigger;
  }

  openMenuDrawer(summaryElement) {
    var wishlistPopup = document.querySelector('wishlist-popup');

    if (wishlistPopup) {
      wishlistPopup.hide();
    }

    this.resetScrollPosition();

    if (this.mainDetailsToggle) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
    }

    if (this.trigger) {
      this.trigger.setAttribute('aria-expanded', true);
      trapFocus(this.gradient, this.trigger);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    if (this.gradient) {
      this.gradient.classList.add('open');
    }

    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add(`menu-drawer-open`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');

        details.querySelectorAll("summary[aria-expanded='true']").forEach((summary) => {
          summary.setAttribute('aria-expanded', false);
        });
      });

      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });

      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }

    if (this.gradient) {
      this.gradient.classList.remove('open');
    }

    if (this.trigger) {
      this.trigger.setAttribute('aria-expanded', false);

      removeTrapFocus(this.trigger);
    }

    document.body.classList.remove(`overflow-hidden-mobile`);
    document.body.classList.remove(`overflow-hidden-tablet`);
    document.body.classList.remove(`overflow-hidden-desktop`);

    document.body.classList.remove(`menu-drawer-open`);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    if (this.mainDetailsToggle) {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
      });
    }
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');

    if (detailsElement) {
      this.closeSubmenu(detailsElement);
    } else {
      const menuGradient = this.querySelector('.menu-gradient');
      if (menuGradient) {
        menuGradient.classList.remove('open');
      }
    }
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  resetScrollPosition() {
    this.querySelectorAll('.slider').forEach((slider) => {
      slider.classList.add('scroll-reset');

      setTimeout(() => {
        slider.scrollTo(0, 0);
        slider.classList.remove('scroll-reset');
      }, 1);
    });
  }
}

customElements.define('menu-drawer', MenuDrawer);

class MenuDrawerTrigger extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('button');
    this.menu = document.querySelector(`#${this.trigger.getAttribute('aria-controls')}`);

    if (this.trigger) {
      this.trigger.addEventListener('click', this.openMenuDrawer.bind(this));
    }
  }

  openMenuDrawer(e) {
    e.preventDefault();

    this.menu.setTrigger(this.trigger);
    this.menu.openMenuDrawer(this.trigger);
  }
}

customElements.define('menu-drawer-trigger', MenuDrawerTrigger);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.gradient = this.querySelector('.menu-gradient');

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');

    this.search_trigger = this.querySelector('[data-open-search]');

    if (this.gradient) {
      this.gradient.addEventListener('click', this.forceClose.bind(this));
    } else {
      this.addEventListener('click', this.gradientClose.bind(this));
    }

    if (this.search_trigger) {
      this.search_trigger.addEventListener('click', this.openSearch.bind(this));
    }
  }

  openSearch() {
    super.closeMenuDrawer(this, this.summary);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);

    document.querySelector('#Details-search-drawer-container summary').click();
  }

  gradientClose(e) {
    if (e.target === this.details) {
      super.closeMenuDrawer(this, this.summary);
      this.header.classList.remove('menu-open');
      window.removeEventListener('resize', this.onResize);
    }
  }

  forceClose(e) {
    if (e.target === this.gradient) {
      super.closeMenuDrawer(this, this.summary);
      this.header.classList.remove('menu-open');
      window.removeEventListener('resize', this.onResize);
    }
  }

  openMenuDrawer(summaryElement) {
    this.resetScrollPosition();

    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    //setTimeout(() => {
    this.mainDetailsToggle.classList.add('menu-opening');
    //});

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);

    const detailsElement = summaryElement.parentNode;
    const focus = detailsElement.parentElement.querySelector('.form__input, button');

    if (focus) {
      trapFocus(summaryElement.nextElementSibling, focus);
    } else {
      trapFocus(this.mainDetailsToggle, summaryElement);
    }

    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add(`menu-drawer-open`);
  }

  closeMenuDrawer(event, elementToFocus) {
    //if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.preventClose = this.dataset.preventClose === 'true';

    this.close = this.querySelector('.modal-close');

    this.init();

    if (this.close) {
      this.close.addEventListener('click', this.hide.bind(this));
    }
  }

  init() {
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));

    if (!this.preventClose) {
      this.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') {
          this.hide();
        }
      });
    }

    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else if (!this.preventClose) {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    //window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    //window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;

    this.autoplay = this.dataset.autoplay === 'true';

    poster.addEventListener('click', this.loadContent.bind(this));

    if (this.autoplay) {
      this.loadContent(false);
    }
  }

  loadContent(focus = true) {
    //window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

    this.initialSlide = this.querySelector('.slider__slide--initial');

    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (this.prevButton) this.prevButton.classList.remove('init');
    if (this.nextButton) this.nextButton.classList.remove('init');

    this.dots = this.querySelectorAll('.slider-counter__link');

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));

    if (this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;

    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();

    if (this.initialSlide) {
      this.setSlidePosition(this.initialSlide.offsetLeft);
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    if (this.dots.length > 0) {
      this.dots.forEach((dot) => {
        dot.classList.remove('slider-counter__link--active');
      });

      if (this.currentPage && this.dots[this.currentPage - 1]) {
        this.dots[this.currentPage - 1].classList.add('slider-counter__link--active');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();

    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      if (index === this.currentPage - 1) {
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantRadios extends HTMLElement {
  constructor() {
    super();

    // Get parent with class
    this.productInfo = this.closest('product-info');

    this.originalStyle = this.dataset.handle;
    this.currentStyle = this.dataset.handle;
    this.styleId = this.dataset.styleId;
    this.cacheId = `${this.dataset.styleId}-${window.cacheModifier}`;
    this.updateUrl = this.dataset.updateUrl == 'true';
    this.sectionId = this.dataset.section;
    this.styleUrl = `${window.routes.style_collections}?filter.p.tag=style-id:${this.styleId}`;

    this.template = this.dataset.template;

    this.variants = JSON.parse(this.querySelector(`#ProductVariants-${this.sectionId}`).textContent);

    this.groups = [];
    this.swatchOrder = this.dataset.swatchOrder ? this.dataset.swatchOrder.split(',') : [];
    this.fieldsets = this.querySelectorAll('fieldset');
    this.swatchLists = this.querySelectorAll('[data-color-list]');

    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('mouseover', this.onMouseOver);
    if (window.innerWidth >= 750) {
      this.addEventListener('mouseout', this.onMouseOut);
    }

    this.init();

    if (this.updateUrl) {
      //window.addEventListener('popstate', (e) => {
      //  this.selectStyle(e.state ? e.state.style : this.originalStyle);
      //});
    }
  }

  init() {
    fetch(`${this.styleUrl}&section_id=component_style-swatches`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const swatches = html.querySelectorAll('.product__swatch');

        var swatchesArray = Array.from(swatches);

        if (this.swatchOrder.length > 0) {
          swatchesArray.sort((a, b) => {
            const aIndex = this.swatchOrder.indexOf(a.dataset.swatch);
            const bIndex = this.swatchOrder.indexOf(b.dataset.swatch);

            if (aIndex === -1 && bIndex === -1) return 0;
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;

            return aIndex - bIndex;
          });
        }

        /*
        this.swatchLists.forEach((swatchList) => {
          const colorList = swatchList.dataset.colorList.toLowerCase();

          swatches.forEach((swatch) => {
            var color = swatch.dataset.color;
            var label = swatch.querySelector('label');
            var input = swatch.querySelector('input');

            input.setAttribute('name', `style-${this.sectionId}-${this.currentStyle}`);
            input.setAttribute('id', `StyleSwatch-${this.sectionId}-${this.currentStyle}-${color}`);

            label.setAttribute('for', `StyleSwatch-${this.sectionId}-${this.currentStyle}-${color}`);

            if (colorList.includes(swatch.dataset.color.toLowerCase()) && swatch.dataset.loaded === 'false') {
              if (swatch.dataset.handle === this.currentStyle) {
                this.currentColor = swatch.dataset.color;
                swatch.querySelector('input').checked = true;
              }

              if (swatch.querySelector('variant-tooltip')) {
                swatch.querySelector('variant-tooltip').remove();
              }

              swatchList.appendChild(swatch);
              swatch.dataset.loaded = 'true';
            }
          });
        });
        */

        swatchesArray.forEach((swatch) => {

          if (swatch.dataset.group != '') {
            if (!this.groups.includes(swatch.dataset.group)) {
              this.groups.push(swatch.dataset.group);

              var fieldset = document.createElement('fieldset');
              fieldset.classList.add('product__variant', 'product__variant--style');
              fieldset.setAttribute('data-group', swatch.dataset.group);

              fieldset.innerHTML = `
                <legend class="product__variant-option subtitle subtitle--small">
                  <label class="product__variant-label subtitle">
                    ${swatch.dataset.group}:
                    <span class="product__variant-option--selected body subtitle--lowercase">
                      ${swatch.dataset.handle === this.currentStyle ? swatch.dataset.color : ''}
                    </span>
                  </label>
                </legend>
                <div class="product__swatch-list" data-color-list=""></div>
              `;

              this.insertBefore(fieldset, this.querySelector('.product__options'));

              this.fieldsets = this.querySelectorAll('fieldset');
              this.swatchLists = this.querySelectorAll('[data-color-list]');
            } else {
              var fieldset = this.querySelector(`fieldset[data-group="${swatch.dataset.group}"]`);
            }

            this.insertSwatch(swatch, fieldset.querySelector('[data-color-list]'));
          }

          if (swatch.dataset.loaded === 'false') {
            this.insertSwatch(swatch, this.swatchLists[0]);
          }
        });

        this.swatchLists.forEach((swatchList) => {
          if (swatchList.innerHTML == '') {
            swatchList.parentElement.classList.add('hidden');
          }
        });

        this.colorSwatches = this.querySelectorAll('[data-color-list] .product__swatch');
      });
  }

  insertSwatch(swatch, swatchList) {
    if (swatch.dataset.handle === this.currentStyle) {
      this.currentColor = swatch.dataset.color;
      swatch.querySelector('input').checked = true;
    }

    if (swatch.querySelector('variant-tooltip')) {
      swatch.querySelector('variant-tooltip').remove();
    }

    swatchList.appendChild(swatch);
    swatch.dataset.loaded = 'true';
  }

  onVariantChange(e) {
    const input = e.target;

    this.removeErrorMessage();

    if (input.getAttribute('name').indexOf('style') > -1) {
      this.fetchStyleInfo(input);
    } else {
      this.fetchOptionInfo(input);
    }
  }

  selectStyle(style) {
    this.colorSwatches.forEach((swatch) => {
      const input = swatch.querySelector('input');

      this.removeErrorMessage();

      if (input.value == style) {
        input.checked = true;
        this.fetchStyleInfo(input, false);
      } else {
        input.checked = false;
      }
    });
  }

  fetchStyleInfo(input, pushState = true) {
    const style = input.dataset.style;
    this.currentStyle = style;
    this.currentColor = input.dataset.color;

    const productId = input.dataset.productId;

    /** Selected Color Display **/
    this.querySelectorAll('.product__variant--style').forEach((node) => {
      node.querySelector('.product__variant-option--selected').innerHTML = '';
    });
    input.closest('.product__variant').querySelector('.product__variant-option--selected').innerHTML = this.currentColor;

    fetch(`/products/${style}?section_id=${this.sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const main = html.querySelector(`[id^=MainProduct-]`);

        if (main) {
          if (main.dataset.template != this.template) {
            window.location.href = `/products/${style}`;
            return;
          }
        }

        /** Variant Data **/
        this.variants = JSON.parse(html.querySelector(`#ProductVariants-${this.sectionId}`).textContent);

        /** History **/
        if (this.updateUrl && pushState) {
          window.history.replaceState({ style: style }, '', `/products/${style}`);
        }

        /** Price **/
        this.setPrice(html);

        /** Gallery **/
        const gallerySource = html.getElementById(`MediaGallery-${this.sectionId}`);
        const galleryDestination = document.getElementById(`MediaGallery-${this.sectionId}`);

        if (gallerySource && galleryDestination) galleryDestination.innerHTML = gallerySource.innerHTML;

        /** Linked Products **/
        const linkedSource = html.getElementById(`ProductLink-${this.sectionId}`);
        const linkedDestination = document.getElementById(`ProductLink-${this.sectionId}`);

        if (linkedSource && linkedDestination) linkedDestination.innerHTML = linkedSource.innerHTML;

        /** modal media **/
        const modalSource = html.getElementById(`ProductModal-${this.sectionId}`);
        const modalDestination = document.getElementById(`ProductModal-${this.sectionId}`);

        if (modalSource && modalDestination) {
          modalDestination.innerHTML = modalSource.innerHTML;

          const modalInstance = document.querySelector('modal-dialog');
          if (modalInstance && typeof modalInstance.init === 'function') {
            modalInstance.init();
          }
        }

        /** Text **/
        const textSources = html.querySelectorAll(`.product__text`);

        textSources.forEach((textSource) => {
          const blockId = textSource.dataset.blockId;

          const textDestination = this.productInfo.querySelector(`.product__text[data-block-id='${blockId}']`);

          if (textDestination) {
            textDestination.innerHTML = textSource.innerHTML;

            if (textSource.classList.contains('hidden')) {
              textDestination.classList.add('hidden');
            } else {
              textDestination.classList.remove('hidden');
            }
          }
        });

        this.productInfo.rebindLinks();

        /** Messages **/
        const messageSources = html.querySelectorAll(`.product__bundle-message`);

        messageSources.forEach((messageSource) => {
          const blockId = messageSource.dataset.blockId;

          const messageDestination = this.productInfo.querySelector(`.product__bundle-message[data-block-id='${blockId}']`);

          if (messageDestination) {
            messageDestination.innerHTML = messageSource.innerHTML;
          }
        });

        /** Title **/
        const titleSource = html.getElementById(`Title-${this.sectionId}`);
        const titleDestination = document.getElementById(`Title-${this.sectionId}`);

        if (titleSource && titleDestination) titleDestination.innerHTML = titleSource.innerHTML;

        /** Tags **/
        const tagsSource = html.getElementById(`Tags-${this.sectionId}`);
        const tagsDestination = document.getElementById(`Tags-${this.sectionId}`);

        if (tagsSource && tagsDestination) tagsDestination.innerHTML = tagsSource.innerHTML;

        /** Preorder Message */
        const preorderSource = html.getElementById(`ProductPreorderMessage-${this.sectionId}`);
        const preorderrDestination = document.getElementById(`ProductPreorderMessage-${this.sectionId}`);

        if (preorderSource && preorderrDestination) preorderrDestination.innerHTML = preorderSource.innerHTML;

        /** Properties **/
        const propertiesSource = html.getElementById(`PropertyTags-${this.sectionId}`);
        const propertiesDestination = document.getElementById(`PropertyTags-${this.sectionId}`);

        if (propertiesSource && propertiesDestination) propertiesDestination.innerHTML = propertiesSource.innerHTML;

        /** Options */
        const optionsSource = html.getElementById(`ProductOptions-${this.sectionId}`);
        const optionsDestination = document.getElementById(`ProductOptions-${this.sectionId}`);

        if (optionsSource && optionsDestination) optionsDestination.innerHTML = optionsSource.innerHTML;

        this.currentVariant = this.getCurrentVariant();

        /** Share URL **/
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (shareButton && shareButton.updateUrl) {
          shareButton.updateUrl(`${window.shopUrl}/products/${style}`);
        }

        /** Login Button */
        const accountSource = html.getElementById(`CustomerAccountProduct-${this.sectionId}`);
        const accountDestination = document.getElementById(`CustomerAccountProduct-${this.sectionId}`);

        if (accountSource && accountDestination) accountDestination.innerHTML = accountSource.innerHTML;

        /** Wishlist Button **/
        const wishlistSource = html.getElementById(`ProductWishlistButton-${this.sectionId}`);
        const wishlistDestination = document.getElementById(`ProductWishlistButton-${this.sectionId}`);

        if (wishlistSource && wishlistDestination) wishlistDestination.innerHTML = wishlistSource.innerHTML;

        if (typeof Wishlist == 'object') {
          Wishlist.loadButtons();
        }

        /** Submit button **/
        this.setSubmitButton(html);

        const quickSource = html.getElementById(`ProductQuickviewButton-${this.sectionId}`);
        const quickDestination = document.getElementById(`ProductQuickviewButton-${this.sectionId}`);

        if (quickSource && quickDestination) {
          quickDestination.innerHTML = quickSource.innerHTML;
          quickDestination.setAttribute('href', quickSource.getAttribute('href'));

          if (quickSource.hasAttribute('disabled')) {
            quickDestination.setAttribute('disabled', true);
          } else {
            quickDestination.removeAttribute('disabled');
          }
        }

        /** Recommendations */
        const recommendationsSource = html.getElementById(`ProductRecommendations-${this.sectionId}`);
        const recommendationsDestination = document.getElementById(`ProductRecommendations-${this.sectionId}`);

        if (recommendationsSource && recommendationsDestination) {
          recommendationsDestination.setAttribute('data-url', recommendationsSource.dataset.url);
          recommendationsDestination.load();
        }

        /** Notice **/
        const noticeSource = html.getElementById(`ProductNotice-${this.sectionId}`);
        const noticeDestination = document.getElementById(`ProductNotice-${this.sectionId}`);

        if (noticeSource && noticeDestination) noticeDestination.innerHTML = noticeSource.innerHTML;

        /** Bundle **/
        const bundleSource = html.getElementById(`BundleMessage-${this.sectionId}`);
        const bundleDestination = document.getElementById(`BundleMessage-${this.sectionId}`);

        if (bundleSource && bundleDestination) bundleDestination.innerHTML = bundleSource.innerHTML;

        /** Accordions **/
        const accordionSources = html.querySelectorAll(`.product__accordion`);

        accordionSources.forEach((accordionSource) => {
          const accordionDestination = document.getElementById(`${accordionSource.getAttribute('id')}`);

          if (accordionDestination) {
            accordionDestination.querySelector('.accordion__title').innerHTML = accordionSource.querySelector('.accordion__title').innerHTML;
            accordionDestination.querySelector('.accordion__content').innerHTML = accordionSource.querySelector('.accordion__content').innerHTML;
          }
        });

        /** Recommendations */
        const relatedProducts = document.querySelector('#ProductRecommendations-PDP');

        if (relatedProducts) {
          relatedProducts.setAttribute(
            'data-url',
            `${window.routes.recommendations_url}?section_id=${relatedProducts.dataset.sectionId}&product_id=${productId}&limit=${relatedProducts.dataset.limit}`
          );
          relatedProducts.load();
        }

        /** Size guide **/
        if (this.dataset.quickview == 'true') {
          const sizeGuideSource = html.querySelector(`#SizeGuide-Quickview .menu-drawer`);
          const sizeGuideDestination = document.querySelector(`#SizeGuide-Quickview .menu-drawer`);

          if (sizeGuideSource && sizeGuideDestination) {
            sizeGuideDestination.innerHTML = sizeGuideSource.innerHTML;
          }
        } else {
          const sizeGuideSource = html.querySelector(`#SizeGuide-${this.sectionId} .menu-drawer`);
          const sizeGuideDestination = document.querySelector(`#SizeGuide-${this.sectionId} .menu-drawer`);

          if (sizeGuideSource && sizeGuideDestination) {
            sizeGuideDestination.innerHTML = sizeGuideSource.innerHTML;
          }
        }

        /** Id **/
        this.setId(html);

        /** Other Additional Sections **/
        if (this.updateUrl) {
          const additionalSections = document.querySelectorAll('#MainContent .shopify-section');

          additionalSections.forEach((section) => {
            if (!section.classList.contains('section__no-load')) {
              fetch(`/products/${style}?section_id=${section.getAttribute('id').replace('shopify-section-', '')}`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');

                  const sectionSource = html.querySelector(`#${section.getAttribute('id')} div`);
                  const sectionDestination = section.querySelector('div');

                  if (sectionSource && sectionDestination) {
                    sectionDestination.innerHTML = sectionSource.innerHTML;
                  }
                });
            }
          });

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              //variant: this.currentVariant,
            },
          });

          enableZoomOnHover(2);
        }
      });
  }

  fetchOptionInfo(input) {
    this.currentVariant = this.getCurrentVariant();

    fetch(`/products/${this.currentStyle}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        /** Price **/
        this.setPrice(html);

        /** History **/
        if (this.updateUrl) {
          window.history.replaceState({ style: this.currentStyle }, '', `/products/${this.currentStyle}?variant=${this.currentVariant.id}`);
        }

        /** Wishlist **/
        const wishlistSource = html.getElementById(`ProductWishlistButton-${this.sectionId}`);
        const wishlistDestination = document.getElementById(`ProductWishlistButton-${this.sectionId}`);

        if (wishlistSource && wishlistDestination) wishlistDestination.innerHTML = wishlistSource.innerHTML;

        if (typeof Wishlist == 'object') {
          Wishlist.loadButtons();
        }

        const wishlistNewPopupSource = html.getElementById(`WishlistNewListPopup-${this.sectionId}`);
        const wishlistNewPopupDestination = document.getElementById(`WishlistNewListPopup-${this.sectionId}`);

        if (wishlistNewPopupSource && wishlistNewPopupDestination) wishlistNewPopupDestination.innerHTML = wishlistNewPopupSource.innerHTML;

        /** Properties **/
        const propertiesSource = html.getElementById(`PropertyTags-${this.sectionId}`);
        const propertiesDestination = document.getElementById(`PropertyTags-${this.sectionId}`);

        if (propertiesSource && propertiesDestination) propertiesDestination.innerHTML = propertiesSource.innerHTML;

        /** Tags **/
        const tagsSource = html.getElementById(`Tags-${this.sectionId}`);
        const tagsDestination = document.getElementById(`Tags-${this.sectionId}`);

        if (tagsSource && tagsDestination) tagsDestination.innerHTML = tagsSource.innerHTML;

        /** Preorder Message */
        const preorderSource = html.getElementById(`ProductPreorderMessage-${this.sectionId}`);
        const preorderrDestination = document.getElementById(`ProductPreorderMessage-${this.sectionId}`);

        if (preorderSource && preorderrDestination) preorderrDestination.innerHTML = preorderSource.innerHTML;

        /** Submit button **/
        this.setSubmitButton(html);

        /** Id **/
        this.setId(html);

        /** Size Guide **/
        if (this.dataset.quickview == 'true') {
          this.sizeGuide = document.querySelector(`#SizeGuide-Quickview size-guide`);
        } else {
          this.sizeGuide = document.querySelector(`#SizeGuide-${this.sectionId} size-guide`);
        }

        if (this.sizeGuide) {
          let option1 = this.currentVariant.option1;

          this.sizeGuide.setSize(option1);
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  getCurrentVariant() {
    var options = [];
    var currentVariant = false;

    this.querySelectorAll('.product__swatch-radio--options:checked').forEach((input) => {
      options.push(input.value);
    });

    this.variants.forEach((variant) => {
      if (JSON.stringify(variant.options) === JSON.stringify(options)) {
        currentVariant = variant;
        return false;
      }
    });

    return currentVariant;
  }

  onMouseOver(e) {
    let target = e.target;
    let sibling = target.previousElementSibling;

    if (sibling && sibling.disabled) {
      return;
    }

    if (target.classList.contains('product__swatch-label--style')) {
      // Swap out the color group with the current hovered color.
      let color = target.parentElement.dataset.color;
      let container = target.closest('.product__variant');

      container.querySelector('.product__variant-option--selected').innerHTML = color;
    } else if (target.classList.contains('product__swatch-label--options')) {
      let container = target.closest('.product__variant');
      let label = target.getAttribute('data-label');
      let option_name = target.getAttribute('data-option-name');
      let quantity = parseInt(target.getAttribute('data-variant-quantity'));
      let preorder = target.getAttribute('data-preorder') == 'true';
      let string = label;
      if (option_name.toLowerCase() == 'size') {
        if (quantity == 0 && !preorder) {
          //string = `${label} - Sold Out`;
        } else if (quantity <= 5) {
          // Low stock left // item left
          //string = `${label} - ${quantity} item${quantity == 1 ? '' : 's'} left`;
        }
      }
      container.querySelector('.product__variant-option--selected').innerHTML = string;
    }
  }

  onMouseOut(e) {
    if (e.target.classList.contains('product__swatch-label--style')) {
      // Clear the color group.
      let container = e.target.closest('.product__variant');
      container.querySelector('.product__variant-option--selected').innerHTML = '';

      // Show the current color in its own color group
      let selectedInput = this.querySelector('.product__swatch-radio--style:checked');
      selectedInput.closest('.product__variant').querySelector('.product__variant-option--selected').innerHTML = this.currentColor;
    } else if (e.target.classList.contains('product__swatch-label--options')) {
      let container = e.target.closest('.product__variant');
      let current = container.querySelector('.product__swatch-radio:checked');

      if (current) {
        container.querySelector('.product__variant-option--selected').innerHTML = current.value;
      } else {
        container.querySelector('.product__variant-option--selected').innerHTML = '';
      }
    }
  }

  setSubmitButton(html) {
    const submitSource = html.getElementById(`ProductFormButton-${this.sectionId}`);
    const submitDestination = document.getElementById(`ProductFormButton-${this.sectionId}`);

    if (submitSource && submitDestination) {
      submitDestination.innerHTML = submitSource.innerHTML;
    }

    /*
    if (submitSource && submitDestination) {
      submitDestination.querySelector('span').innerHTML = submitSource.querySelector('span').innerHTML;

      if (submitSource.hasAttribute('onclick')) {
        submitDestination.setAttribute('onclick', submitSource.getAttribute('onclick'));
      } else {
        submitDestination.removeAttribute('onclick');
      }

      if (submitSource.hasAttribute('disabled')) {
        submitDestination.setAttribute('disabled', true);
      } else {
        submitDestination.removeAttribute('disabled');
      }
    }

    const dynamicSource = html.getElementById(`ProductDynamicButton-${this.sectionId}`);
    const dynamicDestination = document.getElementById(`ProductDynamicButton-${this.sectionId}`);

    if (dynamicSource && dynamicDestination) {
      if (submitSource.hasAttribute('disabled')) {
        dynamicDestination.classList.add('hidden');
      } else {
        dynamicDestination.classList.remove('hidden');
      }

      if (dynamicSource.classList.contains('enabled')) {
        dynamicDestination.classList.add('enabled');
      } else {
        dynamicDestination.classList.remove('enabled');
      }
    }
    */
  }

  setPrice(html) {
    const priceSource = html.getElementById(`Price-${this.sectionId}`);
    const priceDestination = document.getElementById(`Price-${this.sectionId}`);

    if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;

    const price = document.getElementById(`Price-${this.sectionId}`);
    if (price) price.classList.remove('hidden');
  }

  setId(html) {
    if (this.currentVariant) {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }
}

customElements.define('variant-radios', VariantRadios);

class CardSwatches extends HTMLElement {
  constructor() {
    super();

    this.swatchCount = 0;

    this.container = this.parentElement;

    this.originalStyle = this.dataset.handle;
    this.currentStyle = this.dataset.handle;
    this.styleId = this.dataset.styleId;
    this.cacheId = `${this.dataset.styleId}-${window.cacheModifier}`;
    this.sectionId = this.dataset.section;

    this.displayType = this.dataset.displayImage;
    this.hoverType = this.dataset.hoverImage;

    this.priceContainer = this.container.querySelector('.card__content-price');
    this.originalPrice = this.priceContainer.innerHTML;

    localStorage.removeItem(`${this.dataset.styleId}-${parseInt(window.cacheModifier) - 1}`);

    this.link = document.querySelector(`#ProductCardLink-${this.sectionId}-${this.originalStyle}`);
    this.linkTitle = document.querySelector(`#ProductCardTitleLink-${this.sectionId}-${this.originalStyle}`);
    this.mediaContainer = this.link.querySelector('.media');

    this.viewAs = document.querySelector(`view-as-toggle`);

    if (this.viewAs) {
      this.mediaProduct = this.link.querySelector('.media--product');
      this.mediaModel = this.link.querySelector('.media--model');
    }

    this.defaultMedia = false;
    this.productMedia = false;
    this.modelMedia = false;

    this.styleUrl = `${window.routes.style_collections}?filter.p.tag=style-id:${this.styleId}`;
    
    this.imageOverride = this.dataset.imageOverride;

    if (this.mediaContainer) {
      if (window.innerWidth >= 750) {
        this.addEventListener('mouseover', this.onMouseOver);
        this.addEventListener('mouseout', this.onMouseOut);
      } else {
      }
    }

    this.addEventListener('change', this.onVariantChange);

    this.init();
  }

  init() {
    // Load from cache if available
    if (sessionStorage.getItem(this.cacheId)) {
      const swatches = JSON.parse(sessionStorage.getItem(this.cacheId));

      for (const property in swatches) {
        var swatch = new DOMParser().parseFromString(swatches[property], 'text/html').querySelector('.product__swatch');

        var color = swatch.dataset.color;
        var label = swatch.querySelector('label');
        var input = swatch.querySelector('input');

        input.setAttribute('name', `style-${this.sectionId}-${this.currentStyle}`);
        input.setAttribute('id', `StyleSwatch-${this.sectionId}-${this.currentStyle}-${color}`);

        label.setAttribute('for', `StyleSwatch-${this.sectionId}-${this.currentStyle}-${color}`);

        if (swatch.dataset.handle === this.currentStyle) {
          this.prepend(swatch);

          if (!this.productMedia) {
            this.productMedia = swatch.querySelector(`template[data-media='variant-image']`);
          }

          if (!this.modelMedia) {
            this.modelMedia = swatch.querySelector(`template[data-media='1']`);
          }

          if (!this.defaultMedia) {
            if (this.displayType == 'variant') {
              this.defaultMedia = swatch.querySelector(`template[data-media='variant-image']`);
            } else if (this.displayType == '0') {
              this.defaultMedia = swatch.querySelector(`template[data-media='0']`);
            } else if (this.displayType == '1') {
              this.defaultMedia = swatch.querySelector(`template[data-media='1']`);
            }
          }
        } else if (this.swatchCount < 4) {
          this.swatchCount++;
          this.appendChild(swatch);
        }

        swatch.dataset.loaded = 'true';
      }

      if (Object.keys(swatches).length > 5) {
        var div = document.createElement('div');
        div.classList.add('product__swatch');
        div.classList.add('product__swatch--more');
        div.innerHTML = `<a href="/products/${this.currentStyle}" class="product__swatch-label product__swatch-label--style">+${Object.keys(swatches).length - 5}</a>`;
        this.appendChild(div);
      }

      // Jank reset all inputs. A "real" fix would require a pretty substantial refactor
      this.querySelectorAll('.product__swatch input').forEach((node) => {
        node.checked = false;
      });
      for (var i = 0; i < 10; i++) {
        setTimeout(() => {
          this.querySelectorAll('.product__swatch input').forEach((node) => {
            node.checked = false;
          });
        }, i);
      }
    } else {
      let imageOverride = this.dataset.imageOverride;
      let inLifestyleCollection = this.dataset.inLifestyleCollection;
      fetch(`${this.styleUrl}&section_id=component_style-swatches`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const swatches = html.querySelectorAll('.product__swatch');

          var swatchList = {};

          swatches.forEach((swatch, index) => {
            var color = swatch.dataset.color;
            var label = swatch.querySelector('label');
            var input = swatch.querySelector('input');

            input.setAttribute('name', `style-${this.sectionId}-${this.currentStyle}`);
            input.setAttribute('id', `StyleSwatch-${this.sectionId}-${this.currentStyle}-${index}`);

            label.setAttribute('for', `StyleSwatch-${this.sectionId}-${this.currentStyle}-${index}`);

            if (swatch.dataset.handle === this.currentStyle) {
              this.prepend(swatch);
              
              if (this.imageOverride && this.dataset.inLifestyleCollection == 'true') {
                this.productMedia = imageOverride;
                this.modelMedia = imageOverride;
                this.defaultMedia = imageOverride;
              } else {

                if (!this.productMedia) {
                  this.productMedia = swatch.querySelector(`template[data-media='variant-image']`);
                }

                if (!this.modelMedia) {
                  this.modelMedia = swatch.querySelector(`template[data-media='1']`);
                }

                if (!this.defaultMedia) {
                  if (this.displayType == 'variant') {
                    this.defaultMedia = swatch.querySelector(`template[data-media='variant-image']`);
                  } else if (this.displayType == '0') {
                    this.defaultMedia = swatch.querySelector(`template[data-media='0']`);
                  } else if (this.displayType == '1') {
                    this.defaultMedia = swatch.querySelector(`template[data-media='1']`);
                  }
                }
              }
            } else if (this.swatchCount < 4) {
              this.swatchCount++;
              this.appendChild(swatch);
            }

            swatch.dataset.loaded = 'true';

            swatchList[color] = swatch.outerHTML;
          });

          //sessionStorage.setItem(this.cacheId, JSON.stringify(swatchList));

          if (this.innerHTML == '') {
            this.classList.add('hidden');
          }

          if (swatches.length > 5) {
            var div = document.createElement('div');
            div.classList.add('product__swatch');
            div.classList.add('product__swatch--more');
            div.innerHTML = `<a href="/products/${this.currentStyle}" class="product__swatch-label product__swatch-label--style">+${swatches.length - 5}</a>`;
            this.appendChild(div);
          }
        });
    }
  }

  onVariantChange(e) {
    const input = e.target;
    const parent = input.closest('.product__swatch');

    this.setAttribute('data-interact', true);

    this.currentStyle = input.dataset.style;

    if (window.innerWidth >= 750) {
      window.location.href = `/products/${this.currentStyle}`;
    } else {
      // Get the current collection ID for checking lifestyle collections
      var currentCollectionId = this.dataset.collectionId;
      
      // Check if the clicked swatch has lifestyle content media and if current collection is in its lifestyle collections
      var swatchLifestyleMedia = parent.dataset.lifestyleContentMedia;
      var swatchLifestyleCollections = parent.dataset.lifestyleContentCollections;
      var shouldUseSwatchLifestyleMedia = false;
      
      if (swatchLifestyleMedia && swatchLifestyleCollections && currentCollectionId) {
        var lifestyleCollectionIds = swatchLifestyleCollections.split(',');
        shouldUseSwatchLifestyleMedia = lifestyleCollectionIds.includes(currentCollectionId);
      }
      
      // Check if this swatch represents the current product and if we should use current product's lifestyle media
      var swatchHandle = parent.dataset.handle;
      var currentProductHandle = this.originalStyle;
      var isCurrentProductSwatch = swatchHandle === currentProductHandle;
      var shouldUseCurrentProductLifestyleMedia = this.dataset.imageOverride && this.dataset.inLifestyleCollection == 'true' && isCurrentProductSwatch;
      
      if (shouldUseSwatchLifestyleMedia) {
        // Use lifestyle content media for mobile when clicking on swatch with lifestyle media
        if (this.viewAs) {
          var lifestyleTemplate = document.createElement('template');
          lifestyleTemplate.innerHTML = `<img src="${swatchLifestyleMedia}" alt="" class="motion-reduce" loading="lazy">`;
          
          this.mediaProduct.innerHTML = '';
          this.mediaProduct.appendChild(lifestyleTemplate.content.cloneNode(true));
          
          this.mediaModel.innerHTML = '';
          this.mediaModel.appendChild(lifestyleTemplate.content.cloneNode(true));
        } else if (this.mediaContainer) {
          var lifestyleTemplate = document.createElement('template');
          lifestyleTemplate.innerHTML = `<img src="${swatchLifestyleMedia}" alt="" class="motion-reduce" loading="lazy">`;
          
          this.mediaContainer.innerHTML = '';
          this.mediaContainer.appendChild(lifestyleTemplate.content.cloneNode(true));
        }
      } else if (shouldUseCurrentProductLifestyleMedia) {
        // Use lifestyle content media for mobile when clicking on current product's swatch
        if (this.viewAs) {
          var lifestyleTemplate = document.createElement('template');
          lifestyleTemplate.innerHTML = `<img src="${this.dataset.imageOverride}" alt="" class="motion-reduce" loading="lazy">`;
          
          this.mediaProduct.innerHTML = '';
          this.mediaProduct.appendChild(lifestyleTemplate.content.cloneNode(true));
          
          this.mediaModel.innerHTML = '';
          this.mediaModel.appendChild(lifestyleTemplate.content.cloneNode(true));
        } else if (this.mediaContainer) {
          var lifestyleTemplate = document.createElement('template');
          lifestyleTemplate.innerHTML = `<img src="${this.dataset.imageOverride}" alt="" class="motion-reduce" loading="lazy">`;
          
          this.mediaContainer.innerHTML = '';
          this.mediaContainer.appendChild(lifestyleTemplate.content.cloneNode(true));
        }
      } else {
        // Use the original logic for regular media (other product swatches or non-lifestyle products)
        if (this.viewAs) {
          var productMedia = parent.querySelector(`template[data-media='variant-image']`);
          var modelMedia = parent.querySelector(`template[data-media='1']`);

          if (productMedia) {
            this.mediaProduct.innerHTML = '';
            this.mediaProduct.appendChild(productMedia.content.cloneNode(true));
          } else {
            this.mediaProduct.innerHTML = '';
            this.mediaProduct.appendChild(this.defaultMedia.content.cloneNode(true));
          }

          if (modelMedia) {
            this.mediaModel.innerHTML = '';
            this.mediaModel.appendChild(modelMedia.content.cloneNode(true));
          } else {
            this.mediaModel.innerHTML = '';
            this.mediaModel.appendChild(this.defaultMedia.content.cloneNode(true));
          }

          var video = this.mediaModel.querySelector('video');

          if (video) {
            video.play();
          }
        } else {
          var media = false;

          if (this.displayType == 'variant') {
            media = parent.querySelector(`template[data-media='variant-image']`);
          } else if (this.displayType == '0') {
            media = parent.querySelector(`template[data-media='0']`);
          } else if (this.displayType == '1') {
            media = parent.querySelector(`template[data-media='1']`);
          }

          if (media) {
            this.mediaContainer.innerHTML = '';
            this.mediaContainer.appendChild(media.content.cloneNode(true));

            var video = this.mediaContainer.querySelector('video');

            if (video) {
              video.play();
            }
          }
        }
      }

      if (parent.querySelector('.product__swatch-price')) {
        var price = parent.querySelector('.product__swatch-price').innerHTML;

        if (this.priceContainer) {
          this.priceContainer.innerHTML = price;
        }
      }

      if (this.link) {
        this.link.setAttribute('href', `/products/${this.currentStyle}`);
      }

      if (this.linkTitle) {
        this.linkTitle.setAttribute('href', `/products/${this.currentStyle}`);
      }

      var quickview = document.querySelector(`#ProductQuickview-${this.sectionId}-${this.originalStyle}`);

      if (quickview) {
        quickview.setAttribute('data-product-handle', this.currentStyle);
        quickview.updateHandle();

        if (this.currentStyle == this.originalStyle) {
          quickview.classList.remove('hidden');
        } else {
          quickview.classList.add('hidden');

          if (window.innerWidth >= 990) {
            window.location.href = `/products/${this.currentStyle}`;
          }
        }
      }
    }
  }

  onMouseOver(e) {
    var target = e.target.parentElement;
    
    if (target.classList.contains('product__swatch')) {
      var media = false;
      
      // Get the current collection ID for checking lifestyle collections
      var currentCollectionId = this.dataset.collectionId;
      
      // Check if the hovered swatch has lifestyle content media and if current collection is in its lifestyle collections
      var swatchLifestyleMedia = target.dataset.lifestyleContentMedia;
      var swatchLifestyleCollections = target.dataset.lifestyleContentCollections;
      var shouldUseSwatchLifestyleMedia = false;
      
      if (swatchLifestyleMedia && swatchLifestyleCollections && currentCollectionId) {
        var lifestyleCollectionIds = swatchLifestyleCollections.split(',');
        shouldUseSwatchLifestyleMedia = lifestyleCollectionIds.includes(currentCollectionId);
      }
      
      // Check if this swatch represents the current product and if we should use current product's lifestyle media
      var swatchHandle = target.dataset.handle;
      var currentProductHandle = this.originalStyle;
      var isCurrentProductSwatch = swatchHandle === currentProductHandle;
      var shouldUseCurrentProductLifestyleMedia = this.dataset.imageOverride && this.dataset.inLifestyleCollection == 'true' && isCurrentProductSwatch;
      
      if (shouldUseSwatchLifestyleMedia) {
        // Use lifestyle content media for the swatch being hovered over
        if (this.viewAs) {
          var lifestyleTemplate = document.createElement('template');
          lifestyleTemplate.innerHTML = `<img src="${swatchLifestyleMedia}" alt="" class="motion-reduce" loading="lazy">`;
          
          this.mediaProduct.innerHTML = '';
          this.mediaProduct.appendChild(lifestyleTemplate.content.cloneNode(true));
          
          this.mediaModel.innerHTML = '';
          this.mediaModel.appendChild(lifestyleTemplate.content.cloneNode(true));
        } else if (this.mediaContainer) {
          var lifestyleTemplate = document.createElement('template');
          lifestyleTemplate.innerHTML = `<img src="${swatchLifestyleMedia}" alt="" class="motion-reduce" loading="lazy">`;
          
          this.mediaContainer.innerHTML = '';
          this.mediaContainer.appendChild(lifestyleTemplate.content.cloneNode(true));
        }
      } else if (shouldUseCurrentProductLifestyleMedia) {
        // Use lifestyle content media only for the current product's swatch
        if (this.viewAs) {
          var lifestyleTemplate = document.createElement('template');
          lifestyleTemplate.innerHTML = `<img src="${this.dataset.imageOverride}" alt="" class="motion-reduce" loading="lazy">`;
          
          this.mediaProduct.innerHTML = '';
          this.mediaProduct.appendChild(lifestyleTemplate.content.cloneNode(true));
          
          this.mediaModel.innerHTML = '';
          this.mediaModel.appendChild(lifestyleTemplate.content.cloneNode(true));
        } else if (this.mediaContainer) {
          var lifestyleTemplate = document.createElement('template');
          lifestyleTemplate.innerHTML = `<img src="${this.dataset.imageOverride}" alt="" class="motion-reduce" loading="lazy">`;
          
          this.mediaContainer.innerHTML = '';
          this.mediaContainer.appendChild(lifestyleTemplate.content.cloneNode(true));
        }
      } else {
        // Use the original logic for regular media (other product swatches or non-lifestyle products)
        if (this.viewAs && !target.classList.contains('product__swatch--more')) {
          var productMedia = target.querySelector(`template[data-media='variant-image']`);
          var modelMedia = target.querySelector(`template[data-media='1']`);

          if (productMedia) {
            this.mediaProduct.innerHTML = '';
            this.mediaProduct.appendChild(productMedia.content.cloneNode(true));
          } else {
            this.mediaProduct.innerHTML = '';
            this.mediaProduct.appendChild(this.defaultMedia.content.cloneNode(true));
          }

          if (modelMedia) {
            this.mediaModel.innerHTML = '';
            this.mediaModel.appendChild(modelMedia.content.cloneNode(true));
          } else {
            this.mediaModel.innerHTML = '';
            this.mediaModel.appendChild(this.defaultMedia.content.cloneNode(true));
          }

          var video = this.mediaModel.querySelector('video');

          if (video) {
            video.play();
          }
        } else if (this.mediaContainer && !target.classList.contains('product__swatch--more')) {
          if (this.hoverType == 'variant') {
            media = target.querySelector(`template[data-media='variant-image']`);
          } else if (this.hoverType == '0') {
            media = target.querySelector(`template[data-media='0']`);
          } else if (this.hoverType == '1') {
            media = target.querySelector(`template[data-media='1']`);
          }

          if (media) {
            this.mediaContainer.innerHTML = '';
            this.mediaContainer.appendChild(media.content.cloneNode(true));
          } else {
            this.mediaContainer.innerHTML = '';
            this.mediaContainer.appendChild(this.defaultMedia.content.cloneNode(true));
          }

          var video = this.mediaContainer.querySelector('video');

          if (video) {
            video.play();
          }
        }
      }
    }

    if (target.querySelector('.product__swatch-price')) {
      var price = target.querySelector('.product__swatch-price').innerHTML;

      if (this.priceContainer) {
        this.priceContainer.innerHTML = price;
      }
    }
  }

  onMouseOut(e) {
    if (this.dataset.imageOverride && this.dataset.inLifestyleCollection == 'true') {
      // Use the current product's lifestyle media override when restoring
      if (this.viewAs) {
        var lifestyleTemplate = document.createElement('template');
        lifestyleTemplate.innerHTML = `<img src="${this.dataset.imageOverride}" alt="" class="motion-reduce" loading="lazy">`;
        
        this.mediaProduct.innerHTML = '';
        this.mediaProduct.appendChild(lifestyleTemplate.content.cloneNode(true));
        
        this.mediaModel.innerHTML = '';
        this.mediaModel.appendChild(lifestyleTemplate.content.cloneNode(true));
      } else if (this.mediaContainer) {
        var lifestyleTemplate = document.createElement('template');
        lifestyleTemplate.innerHTML = `<img src="${this.dataset.imageOverride}" alt="" class="motion-reduce" loading="lazy">`;
        
        this.mediaContainer.innerHTML = '';
        this.mediaContainer.appendChild(lifestyleTemplate.content.cloneNode(true));
      }
    } else {
      // Use the original logic for regular media
      if (this.viewAs) {
        this.mediaProduct.innerHTML = '';
        this.mediaProduct.appendChild(this.productMedia.content.cloneNode(true));

        this.mediaModel.innerHTML = '';
        this.mediaModel.appendChild(this.modelMedia.content.cloneNode(true));

        var video = this.mediaModel.querySelector('video');

        if (video) {
          video.play();
        }
      } else if (this.mediaContainer) {
        this.mediaContainer.innerHTML = '';
        this.mediaContainer.appendChild(this.defaultMedia.content.cloneNode(true));

        var video = this.mediaContainer.querySelector('video');

        if (video) {
          video.play();
        }
      }
    }

    if (this.priceContainer) {
      this.priceContainer.innerHTML = this.originalPrice;
    }
  }
}

customElements.define('card-swatches', CardSwatches);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  load() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        } else {
          this.innerHTML = '';
        }

        if (typeof Wishlist == 'object') {
          Wishlist.loadButtons();
        }

        this.classList.add('loaded');
      })
      .catch((e) => {
        console.error(e);
      });
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.load();
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class QuickviewTrigger extends HTMLElement {
  constructor() {
    super();

    this.handle = this.dataset.productHandle;
    this.productUrl = this.dataset.productUrl;
    this.sectionId = this.dataset.sectionId;

    this.addEventListener('click', this.getQuickview.bind(this));
  }

  updateHandle() {
    this.handle = this.dataset.productHandle;
  }

  getQuickview(e) {
    e.preventDefault();

    if (e.target.closest('.quickview--no-trigger')) {
      return;
    }

    let quickview_url = this.productUrl.indexOf('?') > 1 ? `${this.productUrl}&view=quickview` : `${this.productUrl}?view=quickview`;

    fetch(quickview_url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        var sizeGuide = html.querySelector('#SizeGuide-Quickview');

        if (sizeGuide) {
          document.body.appendChild(sizeGuide);
        }

        var quickview = html.querySelector('#Quickview');

        if (quickview) {
          document.body.appendChild(quickview);
          quickview.show(e.target);

          var details = quickview.querySelector('.product__view-details');

          if (details) {
            details.setAttribute('href', this.productUrl);
          }

          if (typeof Wishlist == 'object') {
            Wishlist.loadButtons();
          }
        }
      });
  }
}

customElements.define('quickview-trigger', QuickviewTrigger);

class QuickviewContainer extends HTMLElement {
  constructor() {
    super();

    this.gradient = this.querySelector('.quickview-gradient');

    this.close = this.querySelector('.product__view-close');

    this.drawer = this.querySelector('.quickview-drawer');

    if (this.gradient) {
      this.gradient.addEventListener('click', this.forceClose.bind(this));
    }

    if (this.close) {
      this.close.addEventListener('click', this.hide.bind(this));
    }

    this.drawer.addEventListener('touchstart', this.handleTouchStart.bind(this));

    this.drawer.addEventListener('touchend', this.handleTouchEnd.bind(this));
  }

  handleTouchStart(e) {
    if (e.changedTouches) {
      this.touch_start = e.changedTouches[0].screenX;
    } else {
      this.touch_start = e.screenX;
    }
  }

  handleTouchEnd(e) {
    if (e.changedTouches) {
      this.touch_end = e.changedTouches[0].screenX;
    } else {
      this.touch_end = e.screenX;
    }

    this.handleSwipe();
  }

  handleSwipe() {
    const delta = this.touch_start - this.touch_end;

    if (delta < -150) {
      this.hide();
    }
  }

  show(opener) {
    this.openedBy = opener;

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('menu-drawer-open');

    setTimeout(() => {
      this.classList.add('quickview--open');
    }, 1);

    trapFocus(this, this.querySelector('[role="dialog"]'));

    Shopify.PaymentButton.init();
  }

  hide() {
    this.classList.remove('quickview--open');

    setTimeout(() => {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('menu-drawer-open');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));

      removeTrapFocus(this.openedBy);
      //window.pauseAllMedia();

      this.remove();

      var sizeGuide = document.querySelector('#SizeGuide-Quickview');

      if (sizeGuide) {
        sizeGuide.remove();
      }
    }, 300);
  }

  forceClose(e) {
    if (e.target === this.gradient) {
      this.hide();
    }
  }
}

customElements.define('quickview-container', QuickviewContainer);

class QuickAdd extends HTMLElement {
  constructor() {
    super();

    this.idSelector = this.querySelector(`[name='QuickaddId']`);
    this.button = this.querySelector(`[name='QuickaddButton']`);

    if (!this.button) {
      return;
    }

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (document.querySelector('cart-drawer')) {
      this.button.setAttribute('aria-haspopup', 'dialog');
    }

    this.button.addEventListener('click', this.addToCart.bind(this));
  }

  addToCart(e) {
    e.preventDefault();

    if (this.idSelector.value == '') {
      this.classList.add('error');

      setTimeout(() => {
        this.classList.remove('error');
      }, 3000);
    } else {
      this.button.setAttribute('aria-disabled', true);
      this.button.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      const formData = {
        items: [
          {
            id: this.idSelector.value,
          },
        ],
      };

      if (this.cart) {
        formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
      }

      fetch(`/cart/add`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/json` },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((response) => {
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        });
    }
  }
}

customElements.define('quick-add', QuickAdd);
